/* global Flickity */

Wee.fn.make('carousels', {
	init: function() {
		var carouselOffPage = document.querySelectorAll('[data-carousel-off-page]'),
			carouselHero = document.querySelectorAll('[data-carousel-hero]'),
			carouselFullText = document.querySelectorAll('[data-carousel-full-text]'),
			carouselAsNavFor = document.querySelectorAll('[data-carousel-as-nav-for]'),
			arrowShape = 'M73.783,83.757L40.183,49.999L73.783,16.245C77.592,12.42 77.592,6.37 73.783,2.866C69.983,-0.955 63.958,-0.955 60.475,2.866L26.875,36.308L20.217,42.991C16.408,46.812 16.408,52.87 20.217,56.37L26.875,63.053L60.475,97.128C64.279,100.957 70.3,100.957 73.783,97.128C77.592,93.307 77.592,87.578 73.783,83.757Z';

		for (var i = 0; i < carouselOffPage.length; i++) {
			var usePrevNext = carouselOffPage[i].dataset.carouselSlideCount > 3;
			carouselOffPage[i].classList.add('is-mobile-only');

			new Flickity(carouselOffPage[i], {
				arrowShape: arrowShape,
				cellAlign: 'left',
				contain: true,
				groupCells: true,
				pageDots: false,
				prevNextButtons: usePrevNext,
				watchCSS: ! usePrevNext
			});
		}

		for (var j = 0; j < carouselHero.length; j++) {
			new Flickity(carouselHero[j], {
				arrowShape: arrowShape,
				cellAlign: 'left',
				pageDots: false,
				wrapAround: true
			});
		}

		for (var k = 0; k < carouselFullText.length; k++) {
			new Flickity(carouselFullText[k], {
				arrowShape: arrowShape,
				pageDots: true,
				prevNextButtons: false,
				wrapAround: true
			});
		}

		for (var k = 0; k < carouselAsNavFor.length; k++) {
			new Flickity(carouselAsNavFor[j], {
				arrowShape: arrowShape,
				cellAlign: 'left',
				pageDots: false,
				wrapAround: true
			});
			const uniqueClassRef = new Date().getTime();
			carouselAsNavFor[j].classList.add('carousel-' + uniqueClassRef);
			const navContainer = carouselAsNavFor[j].parentNode.querySelector('[data-carousel-as-nav-for-nav]');
			if (navContainer) {
				new Flickity(navContainer, {
					arrowShape: arrowShape,
					asNavFor: '.carousel-' + uniqueClassRef,
					pageDots: false,
					// imagesLoaded: true
					contain: true
				});
			}
		}
	}
});
